import * as Facebook from 'fb-sdk-wrapper'
import User from '@/models/User'

const client = new Promise(async resolve => {
  await Facebook.load()
  Facebook.init({ appId: process.env.VUE_APP_FACEBOOK_ID, version: 'v3.3' })
  resolve(Facebook)
})

export default {

  async getLoginStatus () {
    const response = await (await client).getLoginStatus()
    return response
  },

  async login () {
    const response = await (await client).login({ scope: 'email' })
    return response
  },

  async fetchUserProfile () {
    await this.login()
    const response = await (await client).api('/me?fields=id,first_name,last_name,email,gender,location,picture')
    const user = {
      socialid: response.id,
      provider: 'facebook',
      avatar: response.picture.data.url,
      email: response.email,
      name: response.first_name,
      surname: response.last_name,
      gender: response.gender,
      location: response.location && response.location.name
    }
    const userProfile = new User(user)
    return userProfile
  },

  async logout () {
    const response = await (await client).logout()
    return response
  },

  async openShareDialogue (href, quote) {
    (await client).ui({ method: 'share', href, quote }, response => {
      if (!response || (response && response.error_message)) return console.error('Error while posting to Facebook')
      console.log(response)
    })
  }

}
